import { useTranslation } from 'react-i18next';

import { LinkButton } from '@/shared/ui';

/** Any address the application does not know. */
export function NotFoundPage(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <section>
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.text')}</p>
      <LinkButton to="/" variant="primary">
        {t('notFound.home')}
      </LinkButton>
    </section>
  );
}
